export default __webpack_public_path__ + "static/media/02AW1OCT66.bc3381ef.jpg";